import React from 'react'
import { SvgProps, LogoIcon } from 'vvs-uikit'
import { ContextApi } from 'contexts/Localization/types'
import { getVVSMinerMoleMintedUrl } from 'utils/mintedNftCollectionUrls'

// export const VVS_GOTCHI_MAINTENANCE_MODE = false
const MAINTENANCE_MODE_START = new Date('2023-02-21T14:00:00+08:00')
const MAINTENANCE_MODE_END = new Date('2023-02-21T14:30:00+08:00')
export const VVS_GOTCHI_MAINTENANCE_MODE =
  Date.now() > MAINTENANCE_MODE_START.getTime() && Date.now() < MAINTENANCE_MODE_END.getTime()

export const QUEST_ITEMS_PER_PAGE = 10
export const TERMS_AND_CONDITIONS_URL = 'https://docs.vvs.finance/product-guides/vvs-gotchi/terms-and-conditions'
export const FULL_HEALTH_LUCKY_DRAW_URL = 'https://discord.com/channels/905031862639013889/1057899544400121878'

interface VvsGotchiDirectory {
  label: (t: ContextApi['t']) => string
  Icon?: React.FC<SvgProps>
  href?: string
  to?: string
  target?: string
}

export const vvsgotchiDirectories: VvsGotchiDirectory[] = [
  {
    label: (t) => t('VVS Finance'),
    Icon: LogoIcon,
    href: '/',
    target: '_self',
  },
  {
    label: (t) => t('VVSGotchi Wiki'),
    Icon: (props) => <img src="/images/vvsGotchi/book_green.png" alt="Gotchi Wiki book icon" {...props} />,
    href: 'https://docs.vvs.finance/product-guides/vvs-gotchi',
    target: '_blank',
  },
  {
    label: (t) => t('Marketplace'),
    Icon: (props) => <img src="/images/vvsGotchi/cart.png" alt="miner mole marketplaces cart icon" {...props} />,
    href: getVVSMinerMoleMintedUrl(),
    target: '_self',
  },
]
